import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-actions" }
const _hoisted_2 = ["open"]
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = ["disabled"]

import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';
import RefundOrderDialog from './RefundOrderDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderActions',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;
const refundOpen = ref(false);
const cancelOpen = ref(false);
const cancelReason = ref('');
const busy = ref(false);

const orderId = (): string => String(props.detail.id);

async function markFulfilled(): Promise<void> {
    if (!confirm('Отметить заказ как выполненный?')) return;
    await request({ method: 'post', url: `/admin-api/orders/${orderId()}/mark-fulfilled/`, data: {} });
    onDone();
}

async function submitCancel(): Promise<void> {
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/orders/${orderId()}/cancel/`,
            data: { reason: cancelReason.value },
        });
        cancelOpen.value = false;
        onDone();
    } finally {
        busy.value = false;
    }
}

function onDone(): void {
    refundOpen.value = false;
    cancelOpen.value = false;
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (refundOpen.value = true))
    }, "Вернуть средства"),
    _createElementVNode("button", {
      class: "btn btn--primary",
      onClick: markFulfilled
    }, "Отметить выполненным"),
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (cancelOpen.value = true))
    }, "Отменить заказ"),
    (refundOpen.value)
      ? (_openBlock(), _createBlock(RefundOrderDialog, {
          key: 0,
          open: refundOpen.value,
          "order-id": orderId,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (refundOpen.value = false)),
          onDone: onDone
        }, null, 8, ["open"]))
      : _createCommentVNode("", true),
    (cancelOpen.value)
      ? (_openBlock(), _createElementBlock("dialog", {
          key: 1,
          open: cancelOpen.value,
          class: "action-dialog"
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Отменить заказ?", -1)),
          _createElementVNode("label", null, [
            _cache[5] || (_cache[5] = _createTextVNode("Причина ")),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cancelReason).value = $event)),
              rows: "3"
            }, null, 512), [
              [_vModelText, cancelReason.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn--danger",
              disabled: busy.value,
              onClick: submitCancel
            }, _toDisplayString(busy.value ? 'Отменяю…' : 'Отменить'), 9, _hoisted_4),
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (cancelOpen.value = false))
            }, "Назад")
          ])
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})